import axios from 'axios'
import { Cookies } from 'react-cookie'

const cookies = new Cookies()

const api = axios.create({
  headers: { 'Content-Type': 'Application/json; charset=UTF-8' },
  // Authorization: `Bearer ${cookies.get('accessToken') ?? ''}`
  timeout: 30000, // 30초
})
api.interceptors.request.use(config => config)
api.interceptors.response.use(
  response => response,
  error => {
    console.log(error)
  }
)

const apiForm = axios.create({
  headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${cookies.get('accessToken') ?? ''}` },
  method: 'POST',
  timeout: 60000, // 30초
})
apiForm.interceptors.request.use(config => config)
apiForm.interceptors.response.use(
  response => response,
  error => {
    console.log(error)
  }
)

const info = {
  url: {
    development: 'https://dev-r-api.spge.kr',
    test: 'http://3.38.92.198:7080',
    production: 'https://r-api.spge.kr/',
  },
}

api.defaults.baseURL = info.url[process.env.NODE_ENV]
apiForm.defaults.baseURL = info.url[process.env.NODE_ENV]

export { api, axios, apiForm }
